var _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 19.5,
    x2: 17.5,
    y2: 19.5,
    stroke: "#2B2B32",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5L12.75 5ZM11.4697 17.5303C11.7626 17.8232 12.2374 17.8232 12.5303 17.5303L17.3033 12.7574C17.5962 12.4645 17.5962 11.9896 17.3033 11.6967C17.0104 11.4038 16.5355 11.4038 16.2426 11.6967L12 15.9393L7.75736 11.6967C7.46447 11.4038 6.98959 11.4038 6.6967 11.6967C6.40381 11.9896 6.40381 12.4645 6.6967 12.7574L11.4697 17.5303ZM11.25 5L11.25 17L12.75 17L12.75 5L11.25 5Z",
    fill: "#2B2B32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.20131a96.svg";
export { ForwardRef as ReactComponent };